import * as React from "react";
import { forwardRef } from "react";
const SvgPercentageArrow = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 12, fill: "none", viewBox: "0 1 10 12", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#000", stroke: "#000", strokeOpacity: 0.01, d: "M4.992 1.5 9 5.403 7.853 6.721 5.735 4.636V11.5H4.232V4.653L2.147 6.72 1 5.403z", opacity: 0.702 }));
const ForwardRef = forwardRef(SvgPercentageArrow);
export { ForwardRef as ReactComponent };
